import React, { useState, useContext, useEffect, useRef } from "react";
import Menutitle from "../menu/Menutitle";
import Menuitems from "../menu/Menuitems";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";

function Menu(props) {
  const [selectedMenu, setSelectedMenu] = useState(""); // State for selected menu title
  const { isLoader, setLoader } = useContext(LoaderContext);
  //const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  // const [isFetching, setIsFetching] = useState(false);
  // const [isScrolled, setIsScrolled] = useState(false);
  const [lastPage, setLastPage] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  //const scrollableRef = useRef(null); // Ref for the scrollable element

  const payload = {
    limit: Config.PRODUCTS_LIMIT,
  };

  const queryParams = new URLSearchParams(payload).toString();
  const getCategories = async (append) => {
    if (lastPage == props.page) return;
    if (!props.page) return;
    
    setLastPage(props.page);
    setLoader(true);
    let url = `${ENDPOINTS.GET_CATEGORIES}?${queryParams}&page=${props.page}`;
    const response = await API.getWithToken(url);
    setLoader(false);
    if (response.statusText === "OK") {
      if (append) {
        setItems([...items, ...response.data.data.categories]);
      } else {
        setItems(response.data.data.categories);
      }

      if (response.data.data.categories.length) {
        props.setPage((prevPage) => prevPage + 1);
        props.setIsFetching(false);
      }
    }
    setIsDataLoaded(true);
  };

  useEffect(() => {
    if (!props.isFetching) return;
    getCategories(true);
  }, [props.isFetching]);

  useEffect(() => {
    if (props.page === 1) {
      setItems([]); // Clear old items
      setLastPage(null); // Reset lastPage tracking
      getCategories(false); // Fresh load
    }
  }, [props.page]);

  useEffect(() => {
    getCategories(false);
  }, []);

  return (
    <>
      <Menutitle title={selectedMenu} />
      {items.length > 0 && (
        <Menuitems onMenuClick={setSelectedMenu} items={items} />
      )}
      {items.length <= 0 && isDataLoaded && (
        <div className="empty-search-result-wrapper">
          <div className="empty-search-result">No result found</div>
        </div>
      )}
    </>
  );
}

export default Menu;
